import React, { useState, useEffect } from 'react';

import Header from '../header/Header.js';
import Footer from '../footer/Footer.js';
import './facultyReports.css';
import './table.css';
import { getFacultyReportData, getFacultyQualitativeReportData } from '../../utils/CertificateReportsDataApi.js';
import { getPortalAccessStatus } from '../../utils/CertificatePortalAccessController.js';
import { PARAMETER_LOCK_VALUE } from '../../data/CertificatePortalAccessConstants.js';
import { groupRowsByQuestionsId, filterDataByFaculty, generateXSL, generatePDF } from '../../utils/FacultyReportUtils.js';
import { PaginatedTable } from '../pagination/PaginatedTable.js';
import { ClipLoader } from 'react-spinners';

//Dependencias
import CircumIcon from "@klarr-agency/circum-icons-react";


const FacultyReports = ({user}) => {
    const [inputErrors, setInputErrors] = useState({
        nombre: '',
        numeroIdentificacion: '',
    });

    const [loadingData, setLoadingData] = useState(true);
    const [loadingResultData, setLoadingResultData] = useState(false);
    const [resultData, setResultData] = useState(null);
    const [qualitativeResultData, setQualitativeResultData] = useState(null);
    const [searchFilter, setSearchFilter] = useState("");
    const [accessStatus, setAccessStatus] = useState(null);

    useEffect(() => {
        if(user && !user.isAdminRol){
            getFacultyData();
        } else {
            setLoadingData(false);
        }
    }, []);

    async function getFacultyData() {
        try {
            const accessStatus = await getPortalAccessStatus();
            setAccessStatus(accessStatus);

            let apellidos = (user && !user.isAdminRol) ? filters.primerApellido + '%' : filters.primerApellido;
            const result = (user && !user.isAdminRol)
                         ? await getFacultyReportData(user.codProf, null, null, null)
                         : await getFacultyReportData(null, filters.numeroIdentificacion, filters.nombre, apellidos);

            const filteredResult = accessStatus.value === PARAMETER_LOCK_VALUE ? filterReportData(result): result;
            setResultData(filteredResult);

            if(result && result.facultyFilterValues.length === 1){
                setSelectedFaculty(result.facultyFilterValues[0]);
                let anyos = filterDataByFaculty(result.facultyFilterValues[0].value, result.reportData, 'cur_academ');
                anyos.sort((a, b) => {
                    return a.value.localeCompare(b.value);
                });
                let asignaturas = filterDataByFaculty(result.facultyFilterValues[0].value, result.reportData, 'cod_asignatura');
                let modalidades = filterDataByFaculty(result.facultyFilterValues[0].value, result.reportData, 'modalidad');
                modalidades.sort((a, b) => {
                    return a.value.localeCompare(b.value);
                });
                let segmentos = filterDataByFaculty(result.facultyFilterValues[0].value, result.reportData, 'segmento');
                segmentos.sort((a, b) => {
                    return a.value.localeCompare(b.value);
                });
                let grupos = filterDataByFaculty(result.facultyFilterValues[0].value, result.reportData, 'cod_grupo_simple');
                grupos.sort((a, b) => {
                    return a.value.localeCompare(b.value);
                });//o COD_ASIGNATURA
                setAnyosAcademicos(anyos);
                setAsignaturas(asignaturas);
                setModalidades(modalidades);
                setSegmentos(segmentos);
                setIdGrupos(grupos);
                setFilters(filter => ({
                    ...filter,
                    faculty: result.facultyFilterValues[0].value,
                    anyoAcademico: [],
                    modalidad: [],
                    segmento: [],
                    asignatura: [],
                    grupo: []
                }));
            } else {
                setAnyosAcademicos([{label: '--Seleccionar--', value: null}]);
                setAsignaturas([{label: '--Seleccionar--', value: null}]);
                setModalidades([{label: '--Seleccionar--', value: null}]);
                setSegmentos([{label: '--Seleccionar--', value: null}]);
                setIdGrupos([{label: '--Seleccionar--', value: null}]);
                setFilters(filter => ({
                    ...filter,
                    faculty: facultyFilterValues[0]
                }));
                setFilteredRows([]);
            }

        } catch (error) {
            console.error(error);
        } finally {
            setLoadingData(false);
        }
    }

    const [anyosAcademicos, setAnyosAcademicos] = useState([{label: '--Seleccionar--', value: null}]);
    const [modalidades, setModalidades] = useState([{label: '--Seleccionar--', value: null}]);
    const [segmentos, setSegmentos] = useState([{label: '--Seleccionar--', value: null}]);
    const [asignaturas, setAsignaturas] = useState([{label: '--Seleccionar--', value: null}]);
    const [grupos, setIdGrupos] = useState([{label: '--Seleccionar--', value: null}]);
    var facultyFilterValues = (resultData && resultData.facultyFilterValues.length > 1)
    ? [{label: '--Seleccionar--', value: null}, ...resultData.facultyFilterValues]
    : (resultData && resultData.facultyFilterValues.length === 1)
        ? resultData.facultyFilterValues
        : [{label: '--Seleccionar--', value: null}];
    const rows = (resultData) ? resultData.reportData : '';

    const [filters, setFilters] = useState(() => {
        return {
            numeroIdentificacion: (!user.isAdminRol && user.userDocId) ? user.userDocId : '',
            nombre: (!user.isAdminRol && user.givenName) ? user.givenName : '',
            primerApellido: (!user.isAdminRol && user.middleName) ? user.middleName : '',
            segundoApellido: '',
            anyoAcademico: [],
            modalidad: [],
            segmento: [],
            asignatura: [],
            grupo:[],
            faculty: facultyFilterValues[0]
        }
    });

    const [filteredRows, setFilteredRows] = useState([]);
    const [filteredRowsSearch, setFilteredRowsSearch] = useState([]);
    const [selectedFaculty, setSelectedFaculty] = useState(null);
    const [notRows, setNotRows] = useState(false);

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFacultyChange = (event) => {
        const { name, value } = event.target;
        setSelectedFaculty(facultyFilterValues.find((faculty) => faculty.value === value));
        let anyos = filterDataByFaculty(value, resultData.reportData, 'cur_academ');
        anyos.sort((a, b) => {
            return a.value.localeCompare(b.value);
        });
        let asignaturas = filterDataByFaculty(value, resultData.reportData, 'cod_asignatura');
        let modalidades = filterDataByFaculty(value, resultData.reportData, 'modalidad');
        modalidades.sort((a, b) => {
            return a.value.localeCompare(b.value);
        });
        let segmentos = filterDataByFaculty(value, resultData.reportData, 'segmento');
        segmentos.sort((a, b) => {
            return a.value.localeCompare(b.value);
        });
        let grupos = filterDataByFaculty(value, resultData.reportData, 'cod_grupo_simple');
        grupos.sort((a, b) => {
            return a.value.localeCompare(b.value);
        });
        setAnyosAcademicos(anyos);
        setAsignaturas(asignaturas);
        setModalidades(modalidades);
        setSegmentos(segmentos);
        setIdGrupos(grupos);
        setFilters(prev => ({
            ...prev,
            [name]: value,
            anyoAcademico: [],
            modalidad: [],
            segmento: [],
            asignatura: [],
            grupo: []
        }));
        setFilteredRows([]);
        setFilteredRowsSearch([]);
    }

    function filterReportData(result) {
        const currentYear = getCurrentAcademicYear();

        return {
            ...result,
            reportData: result.reportData.filter(item =>
                !currentYear.includes(item.cur_academ)
            )
        };
    }

    function filterQualitativeData(qualitativeData) {
        const currentYear = getCurrentAcademicYear();

        return qualitativeData.filter(item =>
                !currentYear.includes(item.cur_academ)
            );
    }

    function getCurrentAcademicYear() {
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth() + 1;

        if (month >= 9) {
            return [String(year), String(year + 1)];
        } else {
            return [String(year - 1), String(year)];
        }
    }

    const handleFilterMultiPLChange = (event, name) => {
        const { value } = event.target;
        let newFilters;
        setFilters((prevFilters) => {
            const isAlreadySelected = prevFilters[name].some(option => option === value);

            if (isAlreadySelected) {
                newFilters = {
                    ...prevFilters,
                    [name]: prevFilters[name].filter(option => option !== value)
                };
            } else {
                newFilters = {
                    ...prevFilters,
                    [name]: [...prevFilters[name], value]
                };
            }
            if(name !== 'asignatura'){
                recalculateFilterValues(newFilters, resultData.reportData);
            }

            return newFilters;
        });
    };

    function recalculateFilterValues(newFilters, reportData) {
        let sCodAsignaturas = [];
        let asignaturasFiltered =
            [...reportData.map((item) => {
                if((newFilters.anyoAcademico.includes(item.cur_academ) || newFilters.anyoAcademico.length === 0)
                && (newFilters.modalidad.includes(item.modalidad) || newFilters.modalidad.length === 0)
                && (newFilters.segmento.includes(item.segmento) || newFilters.segmento.length === 0)
                && (newFilters.grupo.includes(item['cod_grupo_simple']) || newFilters.grupo.length === 0)
                && item.doc_identi === selectedFaculty.value){
                    if(!sCodAsignaturas.includes(item['cod_asignatura'])){
                        sCodAsignaturas.push(item['cod_asignatura']);
                    }
                    return {
                        label: item['cod_asignatura'] + ' | ' +
                            item['desc_asignatura']  + ' | ' +
                            item['cod_grupo_simple'] + ' | ' +
                            item['desc_titulacion'],
                        value: item['cod_asignatura'] + '-' + item['cod_grupo_simple']
                    }
                };
            })
            .filter((item) => item)
            .filter((item, index, self) =>
                index === self.findIndex((t) => (
                    t.value === item.value
                )
            ))];
        setFilters(prev => ({
            ...prev,
            asignatura: prev.asignatura.filter(option => sCodAsignaturas.includes(option))
        }));
        setAsignaturas(asignaturasFiltered);
    }

    const handleSearcher = (event) => {
        setSearchFilter(event.target.value.toLowerCase());
        if(filteredRowsSearch.length) {
            const searchedRows = filteredRowsSearch.filter(row =>
                row.pregunta?.toLowerCase().includes(event.target.value.toLowerCase()) ||
                row.descripcion?.toLowerCase().includes(event.target.value.toLowerCase())
            );
            setFilteredRows(groupRowsByQuestionsId(searchedRows));
            if(!searchedRows.length){
                setNotRows(true);
            }
        }
    }

    function validateFilters() {
        let newErrors = { nombre: '', numeroIdentificacion: '' };
        setInputErrors(newErrors);
        let hasErrors = false;

        if (!filters.numeroIdentificacion.trim() && (!filters.nombre.trim() || !filters.primerApellido.trim())) {
            newErrors.numeroIdentificacion = 'Debe rellenar el campo número de identificación o nombre y apellido.';
            newErrors.nombre = 'Debe rellenar el campo número de identificación o nombre y apellido.';
            hasErrors = true;
        }

        setInputErrors(newErrors);
        return hasErrors;
    }

    //Filtros
    async function applyFilters() {
        let hasErrors = validateFilters();
        if(!hasErrors && rows){
            let filtered = rows.filter(row =>
                    (filters.numeroIdentificacion === '' || row.doc_identi.includes(filters.numeroIdentificacion)) &&
                    (filters.nombre === '' || row.nombre?.toLowerCase().includes(filters.nombre.toLowerCase().replaceAll('%', ''))) &&
                    (filters.primerApellido === '' || (row.apellido1?.toLowerCase()+' '+row.apellido2?.toLowerCase()).includes(filters.primerApellido.toLowerCase().replaceAll('%', ''))) &&
                    (filters.anyoAcademico.length === 0 || filters.anyoAcademico.some(value => row.cur_academ?.toLowerCase().includes(value.toLowerCase()))) &&
                    (filters.modalidad.length === 0 || filters.modalidad.some(value => row.modalidad?.toLowerCase().includes(value.toLowerCase()))) &&
                    (filters.segmento.length === 0 || filters.segmento.some(value => row.segmento?.toLowerCase().includes(value.toLowerCase()))) &&
                    (filters.grupo.length === 0 || filters.grupo.some(value => row.cod_grupo_simple?.toLowerCase().includes(value.toLowerCase()))) &&
                    (filters.asignatura.length === 0 || filters.asignatura.some(value => (row.cod_asignatura + '-' + row.cod_grupo_simple)?.toLowerCase().includes(value.toLowerCase()))) &&
                    (filters.faculty === row.doc_identi)
            );

            setFilteredRows(groupRowsByQuestionsId(filtered));
            setFilteredRowsSearch(groupRowsByQuestionsId(filtered));
            setSelectedFaculty(facultyFilterValues.find((faculty) => faculty.value === filters.faculty));
            let docId = (user && !user.isAdminRol) ? user.userDocId : filters.faculty;
            const resultQualitativeData = await getFacultyQualitativeReportData(docId, filters.anyoAcademico, filters.asignatura);
            let filteredQualitativeData = [];
            if(resultQualitativeData && resultQualitativeData.reportData && resultQualitativeData.reportData.listaRegistros.length > 0){
                filteredQualitativeData = resultQualitativeData.reportData.listaRegistros.filter(row => (
                    (filters.grupo.length === 0 || filters.grupo.some(value => row.cod_grupo_simple?.toLowerCase().includes(value.toLowerCase()))) &&
                    (filters.asignatura.length === 0 || filters.asignatura.some(value => (row.cod_asignatura + '-' + row.cod_grupo_simple)?.toLowerCase().includes(value.toLowerCase()))) &&
                    (filters.anyoAcademico.length === 0 || filters.anyoAcademico.some(value => row.cur_academ?.toLowerCase().includes(value.toLowerCase())))
                ));
            }
            if(accessStatus.value === PARAMETER_LOCK_VALUE){
               filteredQualitativeData = filterQualitativeData(filteredQualitativeData);
            }
            setQualitativeResultData(filteredQualitativeData.length > 0 ? filteredQualitativeData : null);
        }
        setSearchFilter("");
    };

    async function fetchFaculties() {
        let hasErrors = validateFilters();
        setLoadingResultData(true);

        if(!hasErrors){
            await getFacultyData();
        }
        setLoadingResultData(false);
    }

    async function exportExcel() {
        generateXSL(
            filteredRows,
            facultyFilterValues.find((faculty) => faculty.value === filters.faculty).label,
            qualitativeResultData
        );
    };

    async function exportPDF(){
        generatePDF(
            filters,
            facultyFilterValues.find((faculty) => faculty.value === filters.faculty).label,
            filteredRows,
            qualitativeResultData
        );
    }

    return (
        <div>
            <Header/>
            <div className="report-viewer">
                {loadingData ? (
                    <div className="spinner-container">
                        <ClipLoader color= 'red' loading={loadingData} size={50} />
                    </div>
                ) : (
                    <div>
                        <div>
                            <div className="form-container">
                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="numeroIdentificacion" className={`${inputErrors.numeroIdentificacion ? 'label-error' : ''}`}>Número de identificación (DNI)</label>
                                        <input
                                            className={`form-control ${inputErrors.numeroIdentificacion ? 'input-error' : ''}`}
                                            type="text"
                                            id="numeroIdentificacion"
                                            name="numeroIdentificacion"
                                            onChange={handleFilterChange}
                                            value={filters.numeroIdentificacion}
                                            disabled={!user.isAdminRol}
                                        />
                                        {inputErrors.numeroIdentificacion && <div className="input-error-message">{inputErrors.numeroIdentificacion}</div>}
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label htmlFor="nombre" className={`${inputErrors.nombre ? 'label-error' : ''}`}>Nombre</label>
                                            <input
                                                className={`form-control ${inputErrors.nombre ? 'input-error' : ''}`}
                                                type="text"
                                                id="nombre"
                                                name="nombre"
                                                onChange={handleFilterChange}
                                                value={filters.nombre}
                                                disabled={!user.isAdminRol}
                                            />
                                            {inputErrors.nombre && <div className="input-error-message">{inputErrors.nombre}</div>}
                                        </div>
                                        <div className="form-group margin-info">
                                            <label htmlFor="primerApellido" className={`${inputErrors.nombre ? 'label-error' : ''}`}>Apellidos</label>
                                            <input
                                                className={`form-control ${inputErrors.nombre ? 'input-error' : ''}`}
                                                type="text"
                                                id="primerApellido"
                                                name="primerApellido"
                                                onChange={handleFilterChange}
                                                value={filters.primerApellido}
                                                disabled={!user.isAdminRol}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {user.isAdminRol ? (
                                    <div>
                                        <div className="form-row button-container">
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={fetchFaculties}
                                            >
                                                Buscar profesores
                                            </button>
                                        </div>
                                        <div className="form-row adminFacultySearch">
                                            <div className="form-group">
                                                <label htmlFor="centro">Profesor</label>
                                                <select
                                                    className="form-control"
                                                    id="faculty"
                                                    name="faculty"
                                                    onChange={handleFacultyChange}
                                                    value={filters.faculty}
                                                >
                                                {facultyFilterValues.map(({ label, value }) => (
                                                    <option key={value} value={value}>{label}</option>
                                                ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                                <div className="form-row">
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label htmlFor="anyoAcademico">Año académico</label>
                                            <select
                                                className="form-control"
                                                id="anyoAcademico"
                                                name="anyoAcademico"
                                                onClick={(e) => handleFilterMultiPLChange(e, "anyoAcademico")}
                                                value={filters.anyoAcademico}
                                                multiple={true}
                                            >
                                                {anyosAcademicos.map(anyoAcademico => (
                                                    <option key={anyoAcademico.value} value={anyoAcademico.value}>{anyoAcademico.label}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="modalidad">Modalidad</label>
                                            <select
                                                className="form-control"
                                                id="modalidad"
                                                name="modalidad"
                                                onClick={(e) => handleFilterMultiPLChange(e, "modalidad")}
                                                value={filters.modalidad}
                                                multiple={true}
                                            >
                                                {modalidades.map(modalidad => (
                                                    <option key={modalidad.value} value={modalidad.value}>{(modalidad.value != null) ? modalidad.label.toUpperCase() : modalidad.label}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="segmento">Segmento</label>
                                            <select
                                                className="form-control"
                                                id="segmento"
                                                name="segmento"
                                                onClick={(e) => handleFilterMultiPLChange(e, "segmento")}
                                                value={filters.segmento}
                                                multiple={true}
                                            >
                                                {segmentos.map(segmento => (
                                                    <option key={segmento.value} value={segmento.value}>{segmento.label}</option>
                                                ))}
                                            </select>
                                        </div>
                                         <div className="form-group">
                                            <label htmlFor="grupo">Grupo</label>
                                            <select
                                                className="form-control"
                                                id="grupo"
                                                name="grupo"
                                                onChange={(e) => handleFilterMultiPLChange(e, "grupo")}
                                                value={filters.grupo}
                                                multiple={true}
                                            >
                                                {grupos.map(grupo => (
                                                    <option key={grupo.value} value={grupo.value}>{grupo.label}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="asignatura">Asignatura</label>
                                        <select
                                            className="form-control"
                                            id="asignatura"
                                            name="asignatura"
                                            onClick={(e) => handleFilterMultiPLChange(e, "asignatura")}
                                            value={filters.asignatura}
                                            multiple={true}
                                        >
                                            {asignaturas.map(asignatura => (
                                                <option key={asignatura.value} value={asignatura.value}>{asignatura.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="form-row button-container">
                                    <button type="button" className="btn btn-primary" onClick={applyFilters}>
                                        Mostrar informe
                                    </button>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div>
                            { (loadingResultData) ? (
                                <div>
                                    <div className="spinner-inner-container">
                                        <ClipLoader color="red" loading={loadingResultData} size={50} />
                                    </div>
                                    <h3 className="text-center">Cargando datos</h3>
                                </div>
                            ) : (!filteredRows.length && !notRows && resultData?.reportData.length > 0 ? (
                                <div>
                                    <h3 className="text-center">Es necesario seleccionar un profesor para generar el informe.</h3>
                                </div>
                            ) : (!filteredRows.length && !notRows ? (
                                <div>
                                    <h3 className="text-center">No hay datos disponibles.</h3>
                                </div>
                            ) : (
                                <div>
                                    <h3 className='profesor-title'>Informe del profesor: {selectedFaculty.label} (NIF - {(selectedFaculty.value != null) ? selectedFaculty.value : ''})</h3>
                                    <div className="bottom-section">
                                        <div className="left-section">
                                            <div className="export-buttons">
                                                <button onClick={exportExcel} type="button" className="btn btn-secondary"><CircumIcon name="share_1" className="share" size="20px"/>&nbsp; Exportar excel</button>
                                                <button onClick={exportPDF} type="button" className="btn btn-secondary"><CircumIcon name="share_1" className="share" size="20px"/>&nbsp; Exportar PDF</button>
                                            </div>
                                            <CircumIcon name="circle_info" size="25px"/>
                                            <div className="digital-signature">
                                                <p>Si existen dudas, enviar un correo a calidad@universidadeuropea.es</p>
                                            </div>
                                        </div>
                                        <div className="search-container">
                                            <input type="search" className="search-input" placeholder="Buscar" value={searchFilter} onChange={handleSearcher} />
                                        </div>
                                    </div>
                                    <table id="reports" className="table-container">
                                        <thead>
                                            <tr class="columnHeaders">
                                                <th class="descriptionColumn">Descripción</th>
                                                <th>N prof</th>
                                                <th>Media prof</th>
                                                <th>N dpto</th>
                                                <th>Media dpto</th>
                                                <th>N facultad</th>
                                                <th>Media facultad</th>
                                                <th>N universidad</th>
                                                <th>Media universidad</th>
                                                <th>N global</th>
                                                <th>Media global</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredRows.map((row, index) => (
                                                <tr key={index}>
                                                <td class="descriptionColumnText">{row.descripcion}</td>
                                                <td>{row.num_resp_prof}</td>
                                                <td>{Number(row.med_resp_prof)?.toFixed(2)}</td>
                                                <td>{row.num_resp_dpto_prof}</td>
                                                <td>{Number(row.med_resp_dpto_prof)?.toFixed(2)}</td>
                                                <td>{row.num_resp_facul_prof}</td>
                                                <td>{Number(row.med_resp_facul_prof)?.toFixed(2)}</td>
                                                <td>{row.num_resp_univ_prof}</td>
                                                <td>{Number(row.med_resp_univ_prof)?.toFixed(2)}</td>
                                                <td>{row.num_resp_anuales}</td>
                                                <td>{Number(row.med_resp_anuales)?.toFixed(2)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="separation-section">
                                        <p className="text-center">A continuación, verás los comentarios cuyas ASIGNATURAS | GRUPOS | TITULACIONES que previamente has seleccionado:</p>
                                    </div>
                                    <PaginatedTable data={qualitativeResultData}/>
                                </div>
                            )))}
                        </div>
                    </div>
                )}
            </div>
            <Footer className="footer"/>
        </div>

    );
};

export default FacultyReports;